import axios from '@/axios';

export default {
  loadData() {
    return axios.get('/Statistics?_limit=-1');
  }
};
